import React from "react";

import SortableItem from "./SortableItem";
import SortableListWrapper from "./SortableListWrapper";

import { SortableContainer } from "react-sortable-hoc";

const SortableList = SortableContainer(({ drawerList }) => {
    return (
        <SortableListWrapper>
            {drawerList.map((info, idx) => (
                <SortableItem key={idx} index={idx} value={info.DRWR_NAME} />
            ))}
        </SortableListWrapper>
    );
});

export default SortableList;
